module.exports = __webpack_public_path__ + "assets/b204faacc29cdd10b9f95be7998598ab.svg";